import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';

import '../css/about/news/article-wrapper.css';
import '../css/about/news/back-button.css';
import '../css/about/news/share-button.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import languageBasedTag from './languageBasedTag';
import getWordingJson from './request/wordingJson';
import getMediaDetail from './request/mediaDetail';
import getPromotionDetail from './request/promotionDetail';
import getScheduleDetail from './request/scheduleDetail';
import wordingSetter from './wordingSetter';
import { uploadUri } from './appConfig';
import defaultBanner from '../images/default-banner.png';
import setArticleLink from './about/setArticleLink';
import setArticleDate from './about/setArticleDate';
import setupTwitterShareLink from './common/setupTwitterShareLink';
import setupFacebookShareLink from './common/setupFacebookShareLink';
import hideLoadingImage from './common/hideLoadingImage';

setup();

document.head.appendChild(
	languageBasedTag(),
);

const pathArray = window.location.pathname.split('/');

/**
 * get the matched api function
 */
const getData = {
	media: getMediaDetail,
	promotions: getPromotionDetail,
	schedules: getScheduleDetail,
}[pathArray[2]];

if (pathArray[2] === 'promotions') {
	document.querySelector('.article-wrapper > .information > a.source')
		.classList
		.add('-booking');
}

const wordingJsonPromise = getWordingJson('article')
	.then((json) => wordingSetter(json));

/**
 * and then you could call this function without checking
 */
const articlePromise = getData(pathArray[3])
	.then((json) => {
		document.querySelector('.banner-wrapper.-article').setAttribute(
			'style',
			`background-image: url(${
				json.banner ? `${uploadUri}/${json.banner}` : defaultBanner
			})`,
		);
		document.querySelector('.article-wrapper > .title').innerText = json.title;

		setArticleLink(json.url);
		setArticleDate(pathArray[2], json);

		document.querySelector('.article-wrapper > .content').innerHTML = json.content;

		/**
		 * Twitter Share
		 */
		setupTwitterShareLink(
			document.querySelector('.share-button > .link.fa-twitter'),
			`【${document.title}】${json.title}`,
		);

		/**
		 * setup the email link
		 */
		document.querySelector('.share-button > .link.fa-envelope-o')
			.setAttribute('href', `mailto:?subject=${json.title}&body=${window.location.href}`);

		/**
		 * setup the Weibo Share link
		 */
		document.querySelector('.share-button > .link.fa-weibo')
			.setAttribute('href', `//service.weibo.com/share/share.php?url=${
				window.location.href
			}&title=【${
				document.title}】${json.title
			}&pic=${
				uploadUri}/${json.banner
			}`);
	})
	.catch(({ error_msg: errorMsg }) => {
		if (errorMsg === 'NOT_FOUND') {
			/**
			 * go to the parent page (list page)
			 */
			window.location.href = pathArray[2];
		}
	});

Promise.all([wordingJsonPromise, articlePromise])
	.then(() => hideLoadingImage());

/**
 * Facebook Share
 */
setupFacebookShareLink(
	document.querySelector('.share-button > .link.fa-facebook'),
);

/**
 * go to the previous page
 */
document.querySelector('.back-button').addEventListener('click', () => {
	window.history.back();
});



// WEBPACK FOOTER //
// ./src/js/article.js